/**
 * A no-op function that returns void.
 * Useful as a placeholder or default callback.
 *
 * @returns void
 *
 * @example
 * ```ts
 * import { Void } from "@pdfking/tfunc"
 *
 * const onClick = condition ? handleClick : Void
 * onClick() // Does nothing if condition is false
 *
 * // As a default parameter
 * function process(callback = Void) {
 *   // ... do work
 *   callback()
 * }
 * ```
 */
export const Void = (): void => {}
